import { Modal } from '@trackman/web-shared-components';
import Paragraph from 'components/TextComps/Paragraph';
import { ReactComponent as TrashIcon } from 'images/icons/Trash.svg';
import { useTranslation } from 'react-i18next';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';
import { useDeleteInvites } from 'queryHooks/Organization/Invites/useDeleteInvites';

type Props = {
  isOpen: boolean;
  inviteIds: string[];
  close: () => void;
};

export const DeleteInvitationsModal = ({ isOpen, inviteIds, close }: Props) => {
  const { t } = useTranslation();
  const selectedOrganizationId = useOrganizationStore((state) => state.selectedOrganizationId);

  const deleteInvites = useDeleteInvites(selectedOrganizationId, { onSuccess: () => close() });

  const confirm = () => deleteInvites.mutate(inviteIds);

  return (
    <Modal
      open={isOpen}
      onClose={close}
      aria-labelledby={t('DeleteInvitations', { ns: 'studentsPage' })}
      aria-describedby={t('DeleteInvitationsFromTheList', { ns: 'studentsPage' })}
      cancelBtn={{
        label: t('Cancel', { ns: 'general' }),
        onClick: () => close(),
        className: 'styled-button secondary',
      }}
      confirmBtn={{
        label: t('Delete', { ns: 'studentsPage' }),
        onClick: () => confirm(),
      }}
      title={t('DeleteInvitations', { ns: 'studentsPage' })}
      titleIcon={<TrashIcon />}
    >
      <div className='modal-body'>
        <Paragraph>
          <strong>{t('AreYouSureYouWantToDeleteInvitationsFromTheList', { ns: 'studentsPage' })}</strong>
        </Paragraph>
        <Paragraph>
          <>{t('InvitationsWillNotBeDeletedFromRecipientsEmail', { ns: 'studentsPage' })}</>
        </Paragraph>
      </div>
    </Modal>
  );
};

export default DeleteInvitationsModal;
